import React, { Component } from "react";
import { Row, Col, Button, Nav, Form } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { PacmanLoader } from "react-spinners";
import "containers/common/Detail.css";
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import "react-table/react-table.css";
import Moment from "moment";
import DatePicker from "react-datepicker";

export default class SLMSaleList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searching: false,
      isLoading: true,
      sales: [],
      filter: {},
    };

    this.deleteSale = this.deleteSale.bind(this);
    this.handleCloneSale = this.handleCloneSale.bind(this);
  }

  async componentDidMount() {
    console.log("In SaleList componentDidMount");

    if (!this.props.isAuthenticated) {
      // if false
      return;
    }

    // try {
    //     const sales = await this.getSales(this.props.filter);
    //     this.setState({ sales });
    //     console.log(sales)
    // } catch (e) {
    //     alert(e);
    // }

    this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this.setState({ sales: [] });
  }

  getSales(filter) {
    console.log("Inside getsales() ");

    return API.get("colin", "/slmsales", { queryStringParameters: filter });
  }

  deleteSale(saleid) {
    return API.del("colin", "/slmsale", { queryStringParameters: saleid });
  }

  handleCloneSale = async (event) => {
    console.log("Clone");
  };

  handleInputChange = (cellInfo, event) => {
    let data = [...this.props.data];
    data[cellInfo.index][cellInfo.column.id] = event.target.value;
    data[cellInfo.index].modified = true;
    this.setState({ data });
  };
  handleNumberChange = (cellInfo, event) => {
    let data = [...this.props.data];
    let val = event.target.value.replace(/[^0-9]/g, "");

    data[cellInfo.index][cellInfo.column.id] = val;
    data[cellInfo.index].modified = true;
    this.setState({ data });
  };
  handleCheckboxChange = (cellInfo, event) => {
    let data = [...this.props.data];
    data[cellInfo.index][cellInfo.column.id] = event.target.checked;
    data[cellInfo.index].modified = true;
    this.setState({ data });
  };

  handleDateChange = (cellInfo, event) => {
    let addresses = [...this.props.data];
    addresses[cellInfo.index][cellInfo.column.id] = new Date(event);
    addresses[cellInfo.index].modified = true;
    this.setState({ addresses });
  };
  renderEditable = (cellInfo) => {
    const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

    switch (typeof cellValue) {
      case "boolean":
        return (
          <Form.Check
            checked={cellValue}
            onChange={this.handleCheckboxChange.bind(null, cellInfo)}
            label=""
            type="checkbox"
            // onBlur={this.handleSave.bind(null, cellInfo)}
          />
        );

      case "number":
        return (
          <input
            onChange={this.handleNumberChange.bind(null, cellInfo)}
            // onBlur={this.handleSave.bind(null, cellInfo)}
            type="number"
            className="no-border form-control"
            value={cellValue != null ? cellValue : " "}
          />
        );

      default:
        if (cellInfo.column.id.indexOf("date") >= 0) {
          return (
            <DatePicker
              selected={cellValue != null ? new Date(cellValue) : ""}
              onChange={this.handleDateChange.bind(null, cellInfo)}
              // onBlur={this.handleSave.bind(null, cellInfo)}
              dateFormat="dd/MM/yyyy"
              className="no-border form-control"
            />
          );
        } else {
          return (
            <input
              onChange={this.handleInputChange.bind(null, cellInfo)}
              // onBlur={this.handleSave.bind(null, cellInfo)}
              type="text"
              className="no-border form-control"
              value={cellValue != null ? cellValue : ""}
            />
          );
        }
    }
  };

  //used in sales search
  renderTable(sales) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const numberFormatter = new Intl.NumberFormat("en-AU", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const columns = [
      {
        id: "selected",
        Header: "",
        maxWidth: 60,
        accessor: "selected",
        Cell: this.renderEditable,
        style: { textAlign: "center" },
      },
      {
        id: "sale_id",
        Header: "Sale ID",
        maxWidth: 60,
        accessor: "sale_id",
        Cell: (e) => (
          <LinkContainer
            to={{
              pathname: `../slmsales/${e.value}`,
              state: {
                data: this.props.data
                  .filter((a) => {
                    if (a.selected) {
                      return true;
                    } else {
                      return false;
                    }
                  })
                  .map((a) => a.sale_id),
              },
            }}
          >
            <a>{e.value}</a>
          </LinkContainer>
        ),
      },
      {
        id: "sale_type",
        Header: "SOLD/For Sale",
        accessor: "sale_type",
        style: { "white-space": "unset" },
      },
      {
        id: "building_name",
        Header: "Building Name",
        accessor: "building_name",
        style: { "white-space": "unset" },
      },
      {
        id: "street_address_full",
        Header: "Address",
        accessor: "street_address_full",
        style: { "white-space": "unset" },
      },
      {
        id: "suburb",
        Header: "Suburb",
        accessor: "suburb",
      },
      {
        id: "state_code",
        Header: "State",
        maxWidth: 60,
        accessor: "state_code",
      },
      {
        id: "postcode",
        Header: "Postcode",
        maxWidth: 60,
        accessor: "postcode",
      },
      {
        id: "stat_date",
        Header: "Stat Date",
        maxWidth: 70,
        accessor: (d) => {
          if (d.stat_date) {
            return Moment(d.stat_date).local().format("DD-MM-YYYY");
          } else {
            return null;
          }
        },
        sortMethod: (a, b) => {
          if (a === b) {
            return 0;
          }
          return new Date(a.split("-")[2], a.split("-")[1] - 1, a.split("-")[0]) > new Date(b.split("-")[2], b.split("-")[1] - 1, b.split("-")[0]) ? 1 : -1;
        },
      },
      {
        id: "sale_price",
        Header: "Price",
        maxWidth: 80,
        accessor: "sale_price",
        sortMethod: (a, b) => {
          if (parseFloat(a.replace("$", "").replace(",", "")) === parseFloat(b.replace("$", "").replace(",", ""))) {
            return 0;
          }
          return parseFloat(a.replace("$", "").replace(",", "")) > parseFloat(b.replace("$", "").replace(",", "")) ? 1 : -1;
        },
      },
      {
        id: "floor_area",
        Header: "Bldg Area",
        maxWidth: 80,
        accessor: (d) => {
          return numberFormatter.format(d.floor_area);
        },
        sortMethod: (a, b) => {
          if (parseFloat(a.replace(",", "")) === parseFloat(b.replace(",", ""))) {
            return 0;
          }
          return parseFloat(a.replace(",", "")) > parseFloat(b.replace(",", "")) ? 1 : -1;
        },
      },
      {
        id: "price_per_sqm",
        maxWidth: 80,
        Header: "Price Per SQM Bldg",
        accessor: (d) => {
          if (!d.sale_price) {
            return "$0.00";
          }
          if (parseFloat(d.sale_price.replaceAll(",", "").replace("$", "")) > 0 && d.floor_area > 0) {
            return formatter.format(parseFloat(d.sale_price.replaceAll(",", "").replace("$", "")) / d.floor_area);
          } else {
            return "$0.00";
          }
        },
        sortMethod: (a, b) => {
          if (parseFloat(a.replace("$", "").replace(",", "")) === parseFloat(b.replace("$", "").replace(",", ""))) {
            return 0;
          }
          return parseFloat(a.replace("$", "").replace(",", "")) > parseFloat(b.replace("$", "").replace(",", "")) ? 1 : -1;
        },
      },
      {
        id: "yield",
        Header: "Yield",
        maxWidth: 50,
        accessor: "yield",
      },
      {
        id: "broad_space_use_code",
        Header: "Broad Space",
        accessor: "broad_space_use_code",
        style: { "white-space": "unset" },
      },
      {
        id: "space_use_name",
        Header: "Space Use",
        accessor: "space_use_name",
        style: { "white-space": "unset" },
      },
      {
        id: "agent",
        Header: "Agent",
        accessor: "agent",
        style: { "white-space": "unset" },
      },
      {
        id: "agency",
        Header: "Agency",
        accessor: "agency",
        style: { "white-space": "unset" },
      },
      {
        id: "purchaser",
        Header: "Buyer",
        accessor: "purchaser",
        style: { "white-space": "unset" },
      },
      // ,

      // {
      //     Header: '',
      //     accessor: 'sale_id',
      //     Cell: row => <button onClick={(e) => this.handleDeleteSale(row.value,e)}>Delete</button>
      // }
    ];

    if (!sales) {
      return null;
    } else {
      return <ReactTable data={sales} columns={columns} defaultPageSize={100} className="-striped -highlight" />;
    }
  }

  renderTable2(sales) {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    const numberFormatter = new Intl.NumberFormat("en-AU", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const columns = [
      {
        id: "sale_id",
        Header: "Sale ID",
        accessor: "sale_id",
        maxWidth: 60,
        Cell: (e) => (
          <LinkContainer to={{ pathname: `../slmsales/${e.value}`, state: { data: this.props.data.map((a) => a.sale_id) } }}>
            <a> {e.value} </a>
          </LinkContainer>
        ),
      },

      {
        id: "title_basis",
        Header: "Title Basis",
        accessor: "title_basis",
      },
      {
        id: "sale_type",
        Header: "Type",
        maxWidth: 80,
        accessor: "sale_type",
      },
      {
        id: "stat_date",
        Header: "Stat Date",
        maxWidth: 80,
        accessor: (d) => {
          if (d.stat_date) {
            return Moment(d.stat_date).local().format("DD-MM-YYYY");
          } else {
            return null;
          }
        },
        sortMethod: (a, b) => {
          if (a === b) {
            return 0;
          }
          return new Date(a) > new Date(b) ? 1 : -1;
        },
      },
      {
        id: "note_data",
        Header: "Sales Notes",
        accessor: "note_data",
        style: { "white-space": "unset" },
        minWidth: 120,
        Cell: (cellInfo) => <Form.Control readOnly value={cellInfo.original.note_data} as="textarea" type="text" rows="1" />,
      },
      {
        id: "sale_price",
        Header: "Price",
        maxWidth: 80,
        accessor: "sale_price",
      },
      {
        id: "floor_area",
        Header: "BldgArea",
        maxWidth: 80,
        accessor: (d) => {
          return numberFormatter.format(d.floor_area);
        },
      },
      {
        id: "price_per_sqm",
        Header: "Price Per SQM",
        accessor: (d) => {
          if (!d.sale_price) {
            return 0;
          }
          if (parseFloat(d.sale_price.replaceAll(",", "").replace("$", "")) > 0 && d.floor_area > 0) {
            return formatter.format(parseFloat(d.sale_price.replaceAll(",", "").replace("$", "")) / d.floor_area);
          } else {
            return 0;
          }
        },
      },
      {
        id: "broad_space_use_code",
        Header: "Broad Use",
        accessor: "broad_space_use_code",
        style: { "white-space": "unset" },
      },
      {
        id: "space_use_name",
        Header: "Space Use",
        accessor: "space_use_name",

        style: { "white-space": "unset" },
      },
      {
        id: "agent",
        Header: "Agent",
        accessor: "agent",
        style: { "white-space": "unset" },
      },
      {
        id: "agency",
        Header: "Agency",
        accessor: "agency",
        style: { "white-space": "unset" },
      },
      {
        id: "purchaser",
        Header: "Buyer",
        accessor: "purchaser",
        style: { "white-space": "unset" },
      },
      {
        Header: "",
        accessor: "sale_id",
        maxWidth: 60,
        Cell: (e) => (
          <LinkContainer to={{ pathname: `/slmsales/new`, state: { clone: e.original } }}>
            <Button type="button" size="sm" variant="primary">
              Clone
            </Button>
          </LinkContainer>
        ),
      },
    ];

    if (!sales) {
      return null;
    } else {
      return <ReactTable data={sales} columns={columns} defaultPageSize={5} className="-striped -highlight" sortable={false} />;
    }
  }

  selectAll = (event) => {
    let sales = [...this.props.data];
    for (var i = 0; i < sales.length; i++) {
      sales[i].selected = true;
    }
    this.setState({ sales });
  };

  deselectAll = (event) => {
    let sales = [...this.props.data];
    for (var i = 0; i < sales.length; i++) {
      sales[i].selected = false;
    }
    this.setState({ sales });
  };

  renderSales() {
    return (
      <div className="sales">
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}

        <Row>
          <Col className="text-left">
            <Nav className="justify-content-start">
              {this.props.controlType !== "table2" && (
                <Nav.Item>
                  <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>
                    Select All
                  </Button>{" "}
                </Nav.Item>
              )}
              {this.props.controlType !== "table2" && (
                <Nav.Item>
                  <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>
                    Deselect All
                  </Button>{" "}
                </Nav.Item>
              )}
            </Nav>
          </Col>

          {this.props.controlType === "table2" && (
            <Col>
              <h5>SOLD/For Sale Transactions</h5>
            </Col>
          )}
          <Col className="text-right">
            {this.props.controlType === "table2" && (
              <LinkContainer to={{ pathname: `/slmsales/new`, state: { address_id: this.props.addressid, address_hard_sequence: this.props.hardsequence, building_name: this.props.buildingname, floor_unit: this.props.floorunit, street_no_low: this.props.streetnolow, street_no_high: this.props.streetnohigh, street_name: this.props.streetname, extension: this.props.extension, suburb: this.props.suburb, state_code: this.props.statecode, postcode: this.props.postcode } }}>
                <Button variant="primary" type="button" size="sm">
                  Add
                </Button>
              </LinkContainer>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <b>
              {this.props.data ? this.props.data.length : "0"} of {this.props.data ? (this.props.data.length > 0 ? this.props.data[0].result_count : "0") : "0"} records returned.
            </b>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12}>
            {!this.state.isLoading ? (this.props.controlType === "table2" ? this.renderTable2(this.props.data) : this.renderTable(this.props.data)) : ""}
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    return <div className="SaleList">{this.props.isAuthenticated ? this.renderSales() : console.log("error)")}</div>;
  }
}
